import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CreateNoteFormValue } from "../analysis-notes.service";

@Component({
    selector: "wfdss-rte-edit-existing-note",
    templateUrl: "./rte-edit-existing-note.component.html",
    styleUrls: ["./rte-edit-existing-note.component.scss"],
    standalone: false
})
export class RTEEditExistingNoteComponent<T> implements OnInit, OnDestroy {
    protected _note: T;
    protected _noteIdAccessor: (note: T) => { [key: string | null]: number } = (s: T) => {
        return null;
    };
    protected _noteType: {type: string, disabled: boolean}[];

    @Input() label: string = "label";
    @Input() set noteType(value:{type: string, disabled: boolean}[]) {
        this._noteType = value;
        if (this._noteType?.length === 1) {
            this.fg.get("type").setValue(this._noteType[0]);
            this.fg.get("type").disable();
        }
    }
    get noteType() {
        return this._noteType;
    }
    @Input() set noteIdAccessor(accessor: (note: T) => { [key: string | null]: number }) {
        this._noteIdAccessor = accessor;
    }
    get noteIdAccessor() {
        return this._noteIdAccessor;
    }
    @Input() set note(note: T) {
        this._note = note;
        this.fg.patchValue(this.note);
        this.fg.markAsPristine();
    }
    get note() {
        return this._note;
    }
    private _noteReadonly = false
    @Input() saveText: string = "Save";
    @Input() set noteReadonly (val: boolean){
        this._noteReadonly = val
        if(this._noteReadonly == true){
            this.fg.get("type").disable()
            this.fg.get("title").disable()
            this.fg.get("content").disable()
        } else {
            this.fg.enable()
        }
    }
    get noteReadonly(){
        return this._noteReadonly
    }
    @Output() save = new EventEmitter<CreateNoteFormValue>();
    @Output() cancel = new EventEmitter();
    fg = new FormGroup({
        type: new FormControl(null, Validators.required),
        title: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
        content: new FormControl(null, Validators.required),
    });
    @Output() formGroupEmit = new EventEmitter();
    disableSave = false;
    stopAutocomplete = new Subject<void>();
    readonly onDestroy = new Subject<void>();
    constructor() {}
    ngOnInit(): void {
        this.formGroupEmit.emit(this.fg);        
        this.fg.statusChanges.subscribe((status) => {
            if(this.noteReadonly){
                this.disableSave = true
            } else {
                if (status === "INVALID") {
                    this.disableSave = true;
                } else if (status === "VALID") {
                    this.disableSave = false;
                }    
            }
        });

        // this.fg
        //     .get("content")
        //     .valueChanges.pipe(takeUntil(this.stopAutocomplete.asObservable()))
        //     .subscribe((cval) => {
        //         if (!this.noteIdAccessor(this.note)) {
        //             if (!this.fg.get("title").touched) {
        //                 this.fg.get("title").setValue(this.getRichTextEditorTextFromBody(cval));
        //             }
        //         }
        //     });
    }

    onSave() {
        if (!this.fg.valid) {
            this.fg.markAllAsTouched();
            this.fg.get("content").markAsDirty();
        } else {
            let saveNoteObject = this.fg.getRawValue();
            const noteIdPropertyAndValue = this.noteIdAccessor(this.note); // uses the implementation specific function to check for an id(updating an existing note)
            if (noteIdPropertyAndValue) {
                Object.assign(saveNoteObject, noteIdPropertyAndValue);
            }
            console.log(saveNoteObject);
            this.save.emit(saveNoteObject);
        }
    }
    onCancel() {
        this.cancel.emit();
    }

    getRichTextEditorTextFromBody(prop: string, isDataUsedForCSV?: boolean) {
        const parser = new DOMParser();
        const rteContent = parser.parseFromString(prop, "text/html");
        const plainText = rteContent.body.textContent ? rteContent.body.textContent : "";
        if (isDataUsedForCSV) {
            return plainText ? plainText : "";
        } else {
            return plainText ? plainText.substring(0, 50) : "";
        }
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
}
